// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const KeyIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="KeyIcon" ref={forwardedRef} {...props}>
      <path d="M13.583 8.185a1.25 1.25 0 1 1-1.768-1.767 1.25 1.25 0 0 1 1.768 1.767" />
      <path d="M8.314 3.858a5.497 5.497 0 0 1 7.774.004 5.497 5.497 0 0 1 .005 7.774 5.48 5.48 0 0 1-4.633 1.556l-.043-.006a12 12 0 0 1-.313-.045l-.753.752h-.81l.17 2.195-2.132-.164.165 2.104-4.848-.234L2 14.22l4.936-4.936c-.537-1.857-.09-3.956 1.378-5.425m6.713 1.065a3.997 3.997 0 0 0-5.652-.005C8.223 6.07 7.931 7.771 8.494 9.212l.178.456-5.01 5.011.418 1.67 2.036.099-.169-2.155 2.132.165-.16-2.066 1.811.001.91-.91.422.12c.15.041.364.07.6.103h.002a3.98 3.98 0 0 0 3.368-1.13 3.997 3.997 0 0 0-.005-5.653" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const KeyIcon = /* @__PURE__ */ Object.assign(KeyIconComponent, {
  displayName: 'KeyIcon',
});
